/** The top of a screen: what it is, and what can be done to it. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "../internal/base.css";
import "./PageHeader.css";

export interface PageHeaderProps {
  readonly title: ReactNode;
  readonly eyebrow?: ReactNode;
  readonly description?: ReactNode;
  readonly actions?: ReactNode;
  readonly divider?: boolean;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function PageHeader({
  title,
  eyebrow,
  description,
  actions,
  divider = false,
  className,
  style,
}: PageHeaderProps) {
  return (
    <header
      className={cn("al-pageheader", divider ? "al-pageheader-divided" : undefined, className)}
      style={style}
    >
      <div className="al-pageheader-main">
        {eyebrow !== undefined ? <div className="al-eyebrow">{eyebrow}</div> : null}
        <h1 className="al-pageheader-title">{title}</h1>
        {description !== undefined ? (
          <div className="al-pageheader-description">{description}</div>
        ) : null}
      </div>
      {actions !== undefined ? <div className="al-pageheader-actions">{actions}</div> : null}
    </header>
  );
}
